// https://stackoverflow.com/questions/42701129/how-to-push-to-history-in-react-router-v4

import {createBrowserHistory} from 'history';

export default createBrowserHistory();
